import { redactEvent } from '@backend/infra-error-tracker/redaction';
import type { ErrorEvent } from '@sentry/node';

// On the server, the SDK attaches the body of the incoming request to every event: on the apply routes, that is the
// candidate's name, email, phone number and resume. It is dropped here instead of never being collected
// (`httpIntegration({ maxIncomingRequestBodySize: 'none' })`) because this module is also bundled for the browser,
// whose SDK has no such integration.
export function redactJobsEvent(event: ErrorEvent): ErrorEvent {
  const redactedEvent = redactEvent(event);
  if (redactedEvent.request?.data === undefined) return redactedEvent;

  const request = { ...redactedEvent.request };
  delete request.data;
  return { ...redactedEvent, request };
}
